import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onefoururbaniaonrentinshirdi() {



    const cardData = {





keyword: "14 Seater Urbania On Rent in Shirdi",
headingDescription: "Sai Shirdi Cab provides 14 Seater Urbania On Rent in Shirdi for families, friends, corporate groups, pilgrimage groups, wedding functions, school and college groups, and travelers who need comfortable transportation for multiple passengers. A 14 seater Urbania is an ideal group travel option when passengers want to stay together in one spacious vehicle rather than arranging several separate cars. Our Urbania rental service can be booked for Shirdi sightseeing, airport transfers, local transportation, religious tours, one-way outstation journeys, round trips, family vacations, corporate travel, and multi-day road trips. With comfortable seating, useful luggage space, and a dedicated vehicle, the 14 seater Urbania is suitable for both short transfers and long-distance journeys from Shirdi. Sai Shirdi Cab can customize the booking according to your pickup location, destination, travel date, trip duration, passenger requirements, and sightseeing plans. Whether you are arranging a pilgrimage, family holiday, group outing, wedding transportation, or an extended outstation tour, our 14 seater Urbania rental service provides a convenient and well-organized travel experience.",
topPlaces: [
{
title: "Pune",
description: "Pune is a convenient outstation destination for groups traveling from Shirdi for corporate meetings, family functions, educational visits, airport transfers, and personal travel. A 14 seater Urbania allows the complete group to travel together while providing comfortable seating and practical space for luggage. Sai Shirdi Cab can arrange the Urbania from Shirdi to Pune according to the group's preferred pickup time, travel schedule, and return requirements, making it suitable for both one-way and round-trip journeys."
},
{
title: "Goa",
description: "Goa is an excellent choice for a multi-day group holiday from Shirdi, particularly for families and friends who want to travel together throughout the road trip. The 14 seater Urbania provides a comfortable group transportation solution with convenient seating and luggage arrangements. Sai Shirdi Cab can customize the Shirdi to Goa Urbania booking with flexible departure timing, travel breaks, sightseeing stops, hotel transfers, and return travel according to the group's planned itinerary."
},
{
title: "Ujjain",
description: "Ujjain is a suitable destination for groups planning a religious road journey from Shirdi and visiting important temples and pilgrimage locations in Madhya Pradesh. A 14 seater Urbania makes it easier for families and pilgrimage groups to remain together throughout the journey without coordinating multiple vehicles. Sai Shirdi Cab can arrange the Urbania for Shirdi to Ujjain travel with customized stops, comfortable seating, luggage space, overnight planning, and options to include additional religious destinations."
},
{
title: "Mumbai",
description: "Mumbai is an important outstation destination for groups traveling from Shirdi for business, family visits, events, airport connections, shopping, and leisure activities. A 14 seater Urbania is a practical choice for larger groups carrying luggage and wanting to avoid splitting passengers between several cars. Sai Shirdi Cab can provide a dedicated Urbania for the Shirdi to Mumbai route with flexible pickup and drop-off points, professional driving, comfortable travel, and one-way or round-trip booking options."
},
{
title: "Bhimashankar",
description: "Bhimashankar is a suitable destination for pilgrimage groups and families looking to combine religious travel with a scenic road journey from Shirdi. The 14 seater Urbania provides enough shared space for a group to travel together while keeping luggage conveniently stored. Sai Shirdi Cab can arrange a customized Urbania trip to Bhimashankar with suitable departure timings and options to include temple visits, nearby sightseeing locations, additional pilgrimage destinations, and return transportation."
},
{
title: "Mahabaleshwar",
description: "Mahabaleshwar is a refreshing hill-station destination for families, friends, and corporate groups planning a group holiday from Shirdi. The 14 seater Urbania is well suited for this type of trip because passengers can remain together while carrying luggage and visiting several sightseeing locations. Sai Shirdi Cab can customize the Urbania rental for Mahabaleshwar with hotel transfers, sightseeing around viewpoints and nearby attractions, flexible travel breaks, and return transportation based on the group's preferred schedule."
},
{
title: "Chhatrapati Sambhajinagar",
description: "Chhatrapati Sambhajinagar, formerly known as Aurangabad, is a useful destination for groups interested in Maharashtra's heritage, historical attractions, temples, and cave sites. A 14 seater Urbania makes it convenient to explore multiple attractions without changing vehicles during the journey. Sai Shirdi Cab can arrange a customized outstation Urbania from Shirdi covering Chhatrapati Sambhajinagar along with nearby destinations such as Ellora, Ajanta, and Grishneshwar according to the group's sightseeing requirements."
},
{
title: "Nashik",
description: "Nashik is a convenient Shirdi-origin destination for families, pilgrimage groups, business travelers, and tourists planning visits to temples, vineyards, and nearby attractions. A 14 seater Urbania provides a comfortable option when several passengers want to travel together with luggage. Sai Shirdi Cab can arrange the Shirdi to Nashik journey with flexible pickup and drop-off locations, convenient travel breaks, and options to extend the itinerary toward Trimbakeshwar or other nearby destinations."
},
{
title: "Ahmednagar",
description: "Ahmednagar can be included in a group travel plan from Shirdi for family visits, business requirements, religious journeys, and regional sightseeing. The 14 seater Urbania is a practical option for groups that want a dedicated vehicle rather than coordinating multiple smaller cabs. Sai Shirdi Cab can provide the Urbania according to the required travel date, passenger count, pickup location, trip duration, and return plan, helping make the journey comfortable and easier to manage."
},
{
title: "Trimbakeshwar",
description: "Trimbakeshwar is an important pilgrimage destination that can be included in a group journey from Shirdi, particularly for families and devotees planning a multi-destination religious tour. A 14 seater Urbania allows passengers to travel together comfortably while carrying personal belongings and luggage. Sai Shirdi Cab can arrange the vehicle for a direct Shirdi to Trimbakeshwar trip or customize a broader itinerary including Nashik and other pilgrimage destinations according to the group's schedule."
}
]
,







"services": [
{
"name": "14 Seater Urbania On Rent in Shirdi",
"description": "14 Seater Urbania On Rent in Shirdi is a spacious and comfortable travel option for families, pilgrimage groups, tourists, and corporate teams. Sai Shirdi Cabs provides well-maintained Urbania vehicles with professional drivers for local sightseeing, airport transfers, family trips, and outstation journeys."
},
{
"name": "14 Seater Force Urbania Rental Shirdi",
"description": "14 Seater Force Urbania Rental Shirdi provides convenient group transportation with comfortable seating and sufficient luggage space. Sai Shirdi Cabs offers private Urbania rental services for pilgrimage tours, family travel, weddings, corporate trips, sightseeing, and customized outstation routes."
},
{
"name": "14 Seater Urbania Hire in Shirdi",
"description": "14 Seater Urbania Hire in Shirdi is suitable for groups that want to travel together in one dedicated vehicle instead of multiple cars. Sai Shirdi Cabs provides flexible Urbania hire with experienced drivers for local travel, temple visits, airport transfers, tours, and long-distance journeys."
},
{
"name": "14 Seater Urbania Booking Shirdi",
"description": "14 Seater Urbania Booking Shirdi allows families and groups to reserve a spacious vehicle according to their planned travel schedule. Sai Shirdi Cabs provides advance booking for pilgrimage tours, family holidays, corporate transportation, weddings, sightseeing programs, airport transfers, and outstation trips."
},
{
"name": "14 Seater Urbania with Driver Shirdi",
"description": "14 Seater Urbania with Driver Shirdi offers a convenient chauffeur-driven travel experience for groups requiring spacious and private transportation. Sai Shirdi Cabs provides professional drivers and comfortable Urbania vehicles for sightseeing, pilgrimage journeys, airport travel, and outstation routes."
},
{
"name": "14 Seater Urbania Cab Shirdi",
"description": "14 Seater Urbania Cab Shirdi is a practical group travel solution for families, friends, pilgrims, and tourists traveling around Shirdi. Sai Shirdi Cabs provides private Urbania cab service for hotel transfers, temple visits, sightseeing, airport transportation, and customized journeys."
},
{
"name": "14 Seater Urbania Taxi Shirdi",
"description": "14 Seater Urbania Taxi Shirdi provides comfortable group transportation with spacious seating for local and outstation travel requirements. Sai Shirdi Cabs offers professionally driven Urbania taxi service for family trips, corporate journeys, pilgrimage tours, sightseeing, and airport transfers."
},
{
"name": "14 Seater Urbania for Outstation Shirdi",
"description": "14 Seater Urbania for Outstation Shirdi is ideal for groups planning a long-distance road trip from Shirdi to another city or tourist destination. Sai Shirdi Cabs provides private Urbania transportation for one-way and round-trip journeys with comfortable seating and convenient luggage capacity."
},
{
"name": "14 Seater Urbania for Family Trip Shirdi",
"description": "14 Seater Urbania for Family Trip Shirdi gives families the convenience of traveling together in one spacious private vehicle. Sai Shirdi Cabs offers comfortable Urbania service for temple visits, holidays, weekend trips, sightseeing, airport transfers, and extended family journeys."
},
{
"name": "14 Seater Urbania for Wedding Shirdi",
"description": "14 Seater Urbania for Wedding Shirdi is suitable for transporting wedding guests and family members between hotels, venues, airports, and other locations. Sai Shirdi Cabs provides spacious and professionally driven Urbania vehicles for wedding functions and related group transportation needs."
},
{
"name": "14 Seater Urbania for Corporate Trip Shirdi",
"description": "14 Seater Urbania for Corporate Trip Shirdi provides organized transportation for employees, business teams, and corporate visitors. Sai Shirdi Cabs offers private Urbania service for meetings, conferences, corporate outings, airport transfers, business travel, and outstation company trips."
},
{
"name": "14 Seater Urbania for Pilgrimage Shirdi",
"description": "14 Seater Urbania for Pilgrimage Shirdi is designed for devotees traveling together to Shirdi and nearby religious destinations. Sai Shirdi Cabs provides comfortable Urbania transportation for temple visits, multi-location pilgrimage tours, and group journeys with professional chauffeur service."
},
{
"name": "14 Seater Urbania for Tour Shirdi",
"description": "14 Seater Urbania for Tour Shirdi offers a convenient group vehicle for sightseeing, family holidays, and multi-destination travel. Sai Shirdi Cabs provides private Urbania transportation for tourists and organized groups visiting Shirdi, nearby attractions, and outstation destinations."
},
{
"name": "14 Seater Urbania One Way Shirdi",
"description": "14 Seater Urbania One Way Shirdi is a convenient choice for groups requiring direct transportation without a return booking. Sai Shirdi Cabs provides one-way Urbania travel from Shirdi to airports, cities, pilgrimage destinations, tourist locations, and other selected routes."
},
{
"name": "14 Seater Urbania Round Trip Shirdi",
"description": "14 Seater Urbania Round Trip Shirdi is ideal for groups planning to return to Shirdi after visiting their destination. Sai Shirdi Cabs offers dedicated Urbania vehicles for family tours, pilgrimage programs, sightseeing trips, corporate journeys, and multi-day outstation travel."
},
{
"name": "14 Seater Urbania Airport Pickup Shirdi",
"description": "14 Seater Urbania Airport Pickup Shirdi provides comfortable group transportation for passengers arriving at Shirdi Airport. Sai Shirdi Cabs can arrange private Urbania pickup for families, pilgrims, corporate travelers, and tour groups with onward transfers to hotels or other destinations."
},
{
"name": "14 Seater Urbania Railway Station Shirdi",
"description": "14 Seater Urbania Railway Station Shirdi is useful for groups arriving by train and requiring spacious transportation from the railway station. Sai Shirdi Cabs provides private Urbania pickup and drop services for hotel transfers, pilgrimage travel, sightseeing, and outstation journeys."
},
{
"name": "14 Seater Urbania Sightseeing Shirdi",
"description": "14 Seater Urbania Sightseeing Shirdi allows families and larger groups to explore Shirdi and nearby attractions together in a comfortable vehicle. Sai Shirdi Cabs provides spacious Urbania transportation with professional drivers for temple visits, local sightseeing, pilgrimage tours, and customized travel plans."
},
{
"name": "Affordable 14 Seater Urbania Rental Shirdi",
"description": "Affordable 14 Seater Urbania Rental Shirdi provides a cost-effective group transportation option while allowing passengers to travel together in one vehicle. Sai Shirdi Cabs offers Urbania rental for family trips, pilgrimage tours, sightseeing, airport transfers, weddings, corporate travel, and outstation journeys."
},
{
"name": "Best 14 Seater Urbania Hire Shirdi",
"description": "Best 14 Seater Urbania Hire Shirdi is suitable for groups looking for spacious, private, and professionally driven transportation. Sai Shirdi Cabs provides Urbania hire for local trips, airport transfers, pilgrimage journeys, family tours, corporate travel, sightseeing, and outstation routes."
},
{
"name": "Sai Shirdi Cabs",
"description": "Sai Shirdi Cabs provides 14 Seater Urbania rental and hire services in Shirdi for families, pilgrims, tourists, corporate groups, and larger travel parties. Customers can arrange comfortable Urbania transportation for airport and railway station transfers, sightseeing, weddings, pilgrimage tours, one-way journeys, round trips, and outstation travel."
}
],
"tableData": [
["14 Seater Urbania On Rent in Shirdi", "14 Seater Force Urbania Rental Shirdi"],
["14 Seater Urbania Hire in Shirdi", "14 Seater Urbania Booking Shirdi"],
["14 Seater Urbania with Driver Shirdi", "14 Seater Urbania Cab Shirdi"],
["14 Seater Urbania Taxi Shirdi", "14 Seater Urbania for Outstation Shirdi"],
["14 Seater Urbania for Family Trip Shirdi", "14 Seater Urbania for Wedding Shirdi"],
["14 Seater Urbania for Corporate Trip Shirdi", "14 Seater Urbania for Pilgrimage Shirdi"],
["14 Seater Urbania for Tour Shirdi", "14 Seater Urbania One Way Shirdi"],
["14 Seater Urbania Round Trip Shirdi", "14 Seater Urbania Airport Pickup Shirdi"],
["14 Seater Urbania Railway Station Shirdi", "14 Seater Urbania Sightseeing Shirdi"],
["Affordable 14 Seater Urbania Rental Shirdi", "Best 14 Seater Urbania Hire Shirdi"],
["Sai Shirdi Cabs", "14 Seater Urbania On Rent in Shirdi"]
]
,





whychoose: [  
 
    {   
 
        WhyChooseheading: "14 Seater Urbania on Rent in Shirdi for Group Travel",   
 
        WhyChoosedescription: "Sai Shirdi Cabs provides 14 Seater Urbania on Rent in Shirdi for families, pilgrimage groups, tourists, corporate teams, wedding guests, and other medium-sized groups. A 14 Seater Urbania can be arranged for Sai Baba Darshan, Shirdi sightseeing, airport and railway station transfers, family functions, religious tours, outstation journeys, and multi-day road trips according to your travel requirements."   
 
    },   
 
    {   
 
        WhyChooseheading: "Comfortable 14 Seater Urbania Rental in Shirdi",   
 
        WhyChoosedescription: "Groups looking for a dedicated vehicle can choose a 14 Seater Urbania for convenient travel around Shirdi and beyond. Sai Shirdi Cabs can plan the rental according to your passenger count, luggage requirements, pickup location, travel date, destination, preferred departure time, and overall itinerary for local or long-distance journeys."   
 
    },   
 
    {   
 
        WhyChooseheading: "14 Seater Urbania for Sai Baba Darshan",   
 
        WhyChoosedescription: "Devotee groups visiting Shirdi can arrange a 14 Seater Urbania for Sai Baba Darshan and other pilgrimage transportation needs. The vehicle can be used for hotel transfers, temple visits, railway station transfers, local movement, and nearby religious locations while allowing the group to travel together throughout the planned journey."   
 
    },   
 
    {   
 
        WhyChooseheading: "14 Seater Urbania for Shirdi Sightseeing",   
 
        WhyChoosedescription: "Tourists and families can rent a 14 Seater Urbania for exploring Shirdi and nearby attractions in a coordinated manner. Your sightseeing plan can include selected destinations, pickup and drop locations, travel timings, passenger requirements, luggage needs, and preferred journey duration for a convenient group outing."   
 
    },   
 
    {   
 
        WhyChooseheading: "14 Seater Urbania for Outstation Travel from Shirdi",   
 
        WhyChoosedescription: "Sai Shirdi Cabs can arrange a 14 Seater Urbania for groups travelling from Shirdi to other cities, pilgrimage destinations, tourist places, and nearby states. One-way, round-trip, and multi-day travel options can be discussed according to the selected destination, travel dates, passenger count, luggage, route, and sightseeing requirements."   
 
    },   
 
    {   
 
        WhyChooseheading: "14 Seater Urbania for Family and Group Tours",   
 
        WhyChoosedescription: "Families, friends, corporate teams, school groups, college groups, and social organizations can use a 14 Seater Urbania for planned group transportation. Travelling together in one vehicle makes it easier to coordinate luggage, sightseeing stops, meal breaks, hotel transfers, religious visits, and other scheduled activities during the trip."   
 
    },   
 
    {   
 
        WhyChooseheading: "14 Seater Urbania for Airport and Railway Transfers",   
 
        WhyChoosedescription: "Passengers arriving at Shirdi Airport or travelling through the railway station can arrange a 14 Seater Urbania for group pickup and drop services. Sai Shirdi Cabs can organize transportation according to your arrival or departure schedule, passenger count, luggage requirements, pickup point, destination, and onward travel plans."   
 
    },   
 
    {   
 
        WhyChooseheading: "Book 14 Seater Urbania on Rent in Shirdi",   
 
        WhyChoosedescription: "To book a 14 Seater Urbania on Rent in Shirdi, contact Sai Shirdi Cabs with your travel date, pickup location, passenger count, destination, luggage information, journey type, and preferred departure time. Complete trip details help in arranging suitable Urbania transportation for pilgrimage, sightseeing, airport transfers, family travel, or outstation journeys."   
 
    }   
 
]   
 
 
}; 
 
const faqData = [ 
 
{ 
 
question: "Can I rent a 14 Seater Urbania in Shirdi?", 
 
answer: "Yes, Sai Shirdi Cabs provides 14 Seater Urbania rental services in Shirdi for families, tourists, pilgrimage groups, corporate teams, and other groups travelling together." 
 
}, 
 
{ 
 
question: "What can I use a 14 Seater Urbania for in Shirdi?", 
 
answer: "A 14 Seater Urbania can be arranged for Sai Baba Darshan, local sightseeing, family trips, airport transfers, railway station transfers, religious tours, events, and outstation journeys." 
 
}, 
 
{ 
 
question: "Is 14 Seater Urbania available for Sai Baba Darshan?", 
 
answer: "Yes, devotee groups can arrange a 14 Seater Urbania for Sai Baba Darshan, hotel transfers, temple visits, railway station transportation, and other planned pilgrimage locations in and around Shirdi." 
 
}, 
 
{ 
 
question: "Can I book a 14 Seater Urbania for Shirdi sightseeing?", 
 
answer: "Yes, a 14 Seater Urbania can be booked for Shirdi sightseeing and nearby attractions according to your selected locations, passenger count, pickup point, travel schedule, and sightseeing requirements." 
 
}, 
 
{ 
 
question: "Can I hire a 14 Seater Urbania from Shirdi for an outstation trip?", 
 
answer: "Yes, you can arrange a 14 Seater Urbania from Shirdi for selected outstation destinations through one-way, round-trip, or multi-day travel arrangements based on your itinerary." 
 
}, 
 
{ 
 
question: "Is a 14 Seater Urbania suitable for family travel?", 
 
answer: "Yes, families can rent a 14 Seater Urbania for vacations, pilgrimage trips, sightseeing, family functions, airport transfers, railway station transfers, and long-distance road journeys." 
 
}, 
 
{ 
 
question: "Can I book a 14 Seater Urbania for airport transfers in Shirdi?", 
 
answer: "Yes, a 14 Seater Urbania can be arranged for Shirdi Airport pickup and drop services based on your arrival or departure schedule, passenger count, luggage, pickup location, and destination." 
 
}, 
 
{ 
 
question: "Can I travel with luggage in a 14 Seater Urbania?", 
 
answer: "Yes, passengers can travel with luggage in a 14 Seater Urbania, and providing the approximate luggage requirements along with the passenger count helps in planning the vehicle arrangement." 
 
}, 
 
{ 
 
question: "Can I book a 14 Seater Urbania for a multi-day trip?", 
 
answer: "Yes, multi-day Urbania rental can be discussed for pilgrimage tours, family vacations, sightseeing trips, group events, and multi-destination road journeys according to your planned itinerary." 
 
}, 
 
{ 
 
question: "How can I book a 14 Seater Urbania on Rent in Shirdi?", 
 
answer: "You can contact Sai Shirdi Cabs with your travel date, pickup location, passenger count, destination, luggage details, preferred departure time, and journey type to arrange a 14 Seater Urbania rental service." 
 
} 
 
]; 
 
const testimonials = [ 
 
{ 
 
id: 1, 
 
name: "Mr. Nitin Sharma", 
 
feedback: "Our group needed one comfortable vehicle for a Shirdi pilgrimage and sightseeing plan, and the 14 Seater Urbania worked well for us. Everyone could travel together while we managed our temple visits, luggage, hotel transfers, and nearby sightseeing without arranging multiple cars.", 
 
rating: 5 
 
}, 
 
{ 
 
id: 2, 
 
name: "Mrs. Ritu Mahajan", 
 
feedback: "During our family trip to Shirdi, having a private Urbania made the transportation simple and convenient. The vehicle arrangement suited our group size and helped us coordinate the airport transfer, Darshan plans, local travel, and return journey comfortably.", 
 
rating: 5 
 
} 
 
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "14 Seater Urbania On Rent in Shirdi",
  "image": "https://www.saishirdicabs.com/assets/images/14-seater-urbania-on-rent-in-shirdi.webp",
  "description":
    "Book a 14 Seater Urbania on Rent in Shirdi with Sai Shirdi Cabs for comfortable, spacious, and reliable group travel. Our 14 Seater Force Urbania is suitable for Sai Baba Darshan, Shirdi sightseeing, family trips, group tours, pilgrimage journeys, weddings, corporate travel, airport transfers, railway station transfers, one-way journeys, round trips, and outstation travel. Get a well-maintained Urbania with a professional driver, convenient pickup and drop locations, affordable rental service, and easy booking assistance.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/14-seater-urbania-on-rent-in-shirdi"
  }
};





    return (
        <div>


<Helmet>
  <title>14 Seater Urbania On Rent in Shirdi | Urbania Rental | +91 7776814559</title>

  <meta
    name="description"
    content="Book a 14 Seater Urbania on Rent in Shirdi with Sai Shirdi Cabs for group travel, Sai Baba Darshan, sightseeing, family trips, weddings and outstation journeys. Get a spacious Urbania with professional driver and easy booking."
  />

  <meta
    name="keywords"
    content="14 Seater Urbania On Rent in Shirdi, 14 Seater Force Urbania Rental Shirdi, 14 Seater Urbania Hire in Shirdi, 14 Seater Urbania Booking Shirdi, 14 Seater Urbania with Driver Shirdi, 14 Seater Urbania Cab Shirdi, 14 Seater Urbania Taxi Shirdi, 14 Seater Urbania for Outstation Shirdi, 14 Seater Urbania for Family Trip Shirdi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/117.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Onefoururbaniaonrentinshirdi;